<mat-card>
    <mat-card-title>
        <div mat-card-image class="toolbar">
            <h1 class="col-xs-8">
                {{'USER_OVERVIEW.TITLE' | translate}}
            </h1>
            <div class="btn-toolbar col-xs-4">
                <div class="btn-group">
                    <button mat-button (click)="globalLogOut()" class="mat-icon-button mat-primary nav-button"
                        [matTooltip]="'USER_OVERVIEW.ACTIONS.LOG_OUT' | translate"
                        [attr.aria-label]="'USER_OVERVIEW.ACTIONS.LOG_OUT' | translate">
                        <mat-icon class="mat24">power_settings_new</mat-icon>
                    </button>
                </div>
                <div class="btn-group">
                    <button mat-button (click)="redirect()" class="mat-icon-button mat-primary nav-button"
                        [matTooltip]="'USER_OVERVIEW.ACTIONS.OPEN_BACK_OFFICE' | translate"
                        [attr.aria-label]="'USER_OVERVIEW.ACTIONS.OPEN_BACK_OFFICE' | translate">
                        <mat-icon class="mat24">build</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content>
        <div *ngIf="isLoading; else ready">
            <app-loading></app-loading>
        </div>
        <ng-template #ready>
            <form (submit)="searchUser()">
                <div *ngIf="showUserView" class="row">
                    <div class="col-sm-12">
                        <div class="pull-right">
                            <button mat-mini-fab [matTooltip]="'USER_OVERVIEW.ACTIONS.LOGOUT_ACTUAL_USER'|translate"
                                (click)="exitActualUser()">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <p class="text-center vertical-center">
                            {{'USER_OVERVIEW.CURRENTLY_LOGGED_IN_AS' | translate}}
                            <span appUserID> {{userControl.value}}</span>
                        </p>
                    </div>
                </div>
                <div *ngIf="!showUserView" class="row">
                    <div class="col-sm-8 col-sm-offset-1">
                        <app-autocomplete-form-field [placeholder]="'userID'" [autocompletionType]="autocompletionType"
                            [formControl]="userControl"> </app-autocomplete-form-field>
                        <div *ngIf="msgErr" class="mat-error">{{ msgErr | translate}}</div>
                    </div>
                    <div class="col-sm-2">
                        <button mat-raised-button color="accent"
                            [disabled]="userControl.invalid">{{'USER_OVERVIEW.SEARCH_BUTTON' | translate}}</button>
                    </div>
                </div>
            </form>
        </ng-template>
    </mat-card-content>
</mat-card>
<router-outlet></router-outlet>